<template>
    <CTable
        v-if="data.page"
        :isLoading="isLoading"
        v-model:columns="data.columns"
        v-model:page="data.page"
        :options="data.tableOptions"
        :manages="data.manages"
        :manageExtras="data.manageExtras"
        :rowActions="data.rowActions"
        :clientSide="true"
        :canRefresh="false"
        :visibleSearch="false"
        :visiblePagination="visiblePagination"
    ></CTable>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../../app.logic";
import { initData, isLoading } from "./manufacture-sample-quantity,logic";
import lodash from "lodash";
import { randomUuid } from "../../../../../utils/util";

export default defineComponent({
    components: {
        CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        dataProp: {},
        itemsKey: {},
        visiblePagination: { default: true }
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        lodash.get(data.useForm.modelRef, props.itemsKey).push({
            quantity: data.useForm.modelRef.refManufactureSampleTemp.quantity,
            refUnit: data.useForm.modelRef.refManufactureSampleTemp.refUnit,
            refPackage: data.useForm.modelRef.refManufactureSampleTemp.refPackage,
            _id: randomUuid() //จำเป็นต้องมีหรอ ;w;?
        });
        initData({ props, data, refs })
        return { props, data, refs, isLoading };
    }
});
</script>